export const LOGO_EMBLEM = "/logo-192.webp";
